export const BATCH_ENABLED_FLAG = 'batchEnabled';
